import React from 'react';
import {ItemScreen} from '../ItemScreen';

export function MobileItemScreen(): JSX.Element | null {
  return <ItemScreen />;
}
